import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field, GradButton } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import api, { errMsg } from "@/lib/api";

export const RotaSecici = ({ istasyonlar, secili, onChange, testid = "rota" }) => {
  const toggle = (id) => onChange(secili.includes(id) ? secili.filter((x) => x !== id) : istasyonlar.filter((i) => secili.includes(i.id) || i.id === id).map((i) => i.id));
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid}>
      {istasyonlar.filter((i) => i.aktif).map((i) => (
        <button type="button" key={i.id} data-testid={`${testid}-${i.kod}`} onClick={() => toggle(i.id)}
          className={`text-xs px-3 py-1 rounded-full border transition-colors ${secili.includes(i.id) ? "grad-bg text-white border-transparent" : "border-white/10 text-muted-foreground hover:text-white"}`}>
          {i.sira}. {i.ad}
        </button>
      ))}
      <span className="text-[11px] text-muted-foreground self-center ml-1">{secili.length ? `${secili.length} istasyon` : "Seçim yok = ürün operasyonlarındaki istasyonlar (yoksa tüm zincir)"}</span>
    </div>
  );
};

export const MalzemeTablo = ({ malzeme }) => !malzeme?.length ? <p className="text-xs text-muted-foreground">Aktif reçete yok — hammadde düşülmeyecek.</p> : (
  <div className="space-y-1" data-testid="malzeme-tablo">
    {malzeme.map((m) => (
      <div key={m.urun_id} className="flex justify-between text-xs" data-testid={`malzeme-${m.kod}`}>
        <span><span className="font-mono text-muted-foreground mr-2">{m.kod}</span>{m.ad}</span>
        <span className={`font-mono ${m.eksik > 0 ? "text-red-300" : "text-emerald-400"}`}>{m.gerekli} / {m.kullanilabilir} {m.birim}{m.eksik > 0 ? ` · eksik ${m.eksik}` : ""}</span>
      </div>
    ))}
  </div>
);

export const IsEmriDialog = ({ ihtiyaclar = [], onerilen, urunler, istasyonlar, depolar, personel, onClose, onSaved }) => {
  const ilk = ihtiyaclar[0];
  const toplam = ihtiyaclar.reduce((t, i) => t + i.miktar, 0);
  const [f, setF] = useState({ urun_id: ilk?.urun_id || onerilen?.urun_id || "", miktar: toplam || onerilen?.miktar || 1, rota_ids: [], hedef_depo_id: depolar.find((d) => d.tip === "mamul")?.id || depolar[0]?.id, ilk_atanan_id: "", termin_tarihi: onerilen?.termin_tarihi || "", notlar: onerilen?.notlar || "" });
  const [malzeme, setMalzeme] = useState([]);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));

  useEffect(() => {
    const u = urunler.find((x) => x.id === f.urun_id);
    if (u) setF((s) => ({ ...s, rota_ids: u.rota || [] }));
  }, [f.urun_id, urunler]);
  useEffect(() => {
    if (f.urun_id && f.miktar > 0) api.get("/uretim/malzeme-kontrol", { params: { urun_id: f.urun_id, miktar: f.miktar } }).then((r) => setMalzeme(r.data));
  }, [f.urun_id, f.miktar]);

  const save = async () => {
    setBusy(true);
    try {
      const body = { ...f, ihtiyac_ids: ihtiyaclar.map((i) => i.id), ilk_atanan_id: f.ilk_atanan_id || null, termin_tarihi: f.termin_tarihi || null };
      const { data } = await api.post("/is-emirleri", body);
      toast.success(`${data.no} oluşturuldu`);
      onSaved(data);
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass max-w-2xl max-h-[92vh] overflow-y-auto erp-scroll" data-testid="is-emri-dialog">
        <DialogHeader><DialogTitle className="font-head">{ihtiyaclar.length ? `İş emri · ${ihtiyaclar.length} sipariş ihtiyacı` : "Stok için üretim emri"}</DialogTitle></DialogHeader>
        {ihtiyaclar.length > 0 && <div className="text-xs text-muted-foreground">{ihtiyaclar.map((i) => `${i.siparis_no} (${i.miktar})`).join(" · ")}</div>}
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Ürün *">
            <SelectBox urun testid="ie-urun" value={f.urun_id} onChange={(v) => set("urun_id", v)}
              options={urunler.filter((u) => ["mamul", "yari_mamul"].includes(u.kategori_tipi) && (!ilk || u.id === ilk.urun_id)).map((u) => ({ value: u.id, label: `${u.kod} · ${u.ad}` }))} />
          </Field>
          <Field label={`Miktar${toplam ? ` (min ${toplam})` : ""}`}><Input data-testid="ie-miktar" type="number" step="any" className="bg-white/5" value={f.miktar} onChange={(e) => set("miktar", Number(e.target.value))} /></Field>
          <Field label="Mamul giriş deposu"><SelectBox testid="ie-depo" value={f.hedef_depo_id} onChange={(v) => set("hedef_depo_id", v)} options={depolar.map((d) => ({ value: d.id, label: d.ad }))} /></Field>
          <Field label="İlk istasyon sorumlusu"><SelectBox testid="ie-atanan" value={f.ilk_atanan_id || "kuyruk"} onChange={(v) => set("ilk_atanan_id", v === "kuyruk" ? "" : v)} options={[{ value: "kuyruk", label: "İstasyon kuyruğu" }, ...personel.map((p) => ({ value: p.id, label: p.name }))]} /></Field>
          {!ihtiyaclar.length && <Field label="Termin"><Input data-testid="ie-termin" type="date" className="bg-white/5" value={f.termin_tarihi} onChange={(e) => set("termin_tarihi", e.target.value)} /></Field>}
          <Field label="Not" className={ihtiyaclar.length ? "sm:col-span-2" : ""}><Input data-testid="ie-not" className="bg-white/5" value={f.notlar} onChange={(e) => set("notlar", e.target.value)} /></Field>
        </div>
        <Field label="Rota (istasyonlar)"><RotaSecici istasyonlar={istasyonlar} secili={f.rota_ids} onChange={(v) => set("rota_ids", v)} testid="ie-rota" /></Field>
        <div className="rounded-xl bg-white/5 p-4"><div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-2">Malzeme kontrolü (gerekli / kullanılabilir)</div><MalzemeTablo malzeme={malzeme} /></div>
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-5 py-2 rounded-full border border-white/10 text-sm hover:bg-white/5" data-testid="ie-vazgec">Vazgeç</button>
          <GradButton onClick={save} disabled={busy} data-testid="ie-kaydet">İş emrini başlat</GradButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};
